"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.backfillThreadManifests = backfillThreadManifests;
const path = __importStar(require("path"));
const thread_1 = require("./thread");
/**
 * `backfill-thread-manifests` migration — create a `thread.md` for every thread
 * that lacks one. Idempotent (skips threads that already have a manifest) and
 * `--dry-run` capable, so it is safe to re-run and to ship in every release: any
 * upgrading `loom install` (here or downstream) backfills the manifests the
 * roadmap needs. The `loom migrate` CLI command runs this.
 */
// Weave-root subdirectories that are not threads.
const RESERVED_SUBDIRS = new Set(['plans', 'done', 'ai-chats', 'ctx', 'refs', '.archive', 'chats']);
async function backfillThreadManifests(opts, deps) {
    const loomRoot = deps.getActiveLoomRoot();
    const weavesDir = path.join(loomRoot, 'loom');
    const created = [];
    const skipped = [];
    const dryRun = !!opts.dryRun;
    if (!(await deps.fs.pathExists(weavesDir)))
        return { created, skipped, dryRun };
    const weaves = await deps.fs.readdir(weavesDir).catch(() => []);
    for (const weaveId of weaves) {
        if (weaveId === '.archive' || weaveId === 'chats')
            continue;
        const weavePath = path.join(weavesDir, weaveId);
        const wstat = await deps.fs.stat(weavePath).catch(() => null);
        if (!wstat?.isDirectory())
            continue;
        const threads = await deps.fs.readdir(weavePath).catch(() => []);
        for (const threadId of threads) {
            if (RESERVED_SUBDIRS.has(threadId))
                continue;
            const threadPath = path.join(weavePath, threadId);
            const tstat = await deps.fs.stat(threadPath).catch(() => null);
            if (!tstat?.isDirectory())
                continue;
            if (await deps.fs.pathExists(path.join(threadPath, 'thread.md'))) {
                skipped.push({ weaveId, threadId });
                continue;
            }
            // Title from the thread idea when present, else the folder slug.
            let title = threadId;
            const ideaPath = path.join(threadPath, `${threadId}-idea.md`);
            if (await deps.fs.pathExists(ideaPath)) {
                try {
                    const idea = (await deps.loadDoc(ideaPath));
                    if (idea.title)
                        title = idea.title;
                }
                catch { /* keep slug */ }
            }
            if (dryRun) {
                created.push({ weaveId, threadId });
                continue;
            }
            const res = await (0, thread_1.createThread)({ weaveId, threadId, title }, { getActiveLoomRoot: deps.getActiveLoomRoot, saveDoc: deps.saveDoc, fs: deps.fs });
            created.push({ weaveId, threadId, id: res.id });
        }
    }
    return { created, skipped, dryRun };
}
